import { Record } from 'immutable';

const UnlinkReservationRequestRecord = Record({
  eventReservationId: null,
  eventId: null,
});

export class UnlinkReservationRequest extends UnlinkReservationRequestRecord {
  eventReservationId: number;
  eventId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/unlink-reservation-request.ts